export default {
	companyName: "IQ Tech"
};
